/**
 *
 * The modals duck. Default export is the reducer
 *
 * Action Types:
 * - COIN_PRODUCTS_MODAL_OPENED
 * - COIN_PRODUCTS_MODAL_CLOSED
 * - EVENT_PRICING_MODAL_CLOSED
 * - EVENT_PRICING_MODAL_OPENED
 * - FAVORITE_MODAL_CLOSED
 * - FAVORITE_MODAL_OPENED
 * - FORGOT_PASSWORD_MODAL_CLOSED
 * - FORGOT_PASSWORD_MODAL_OPENED
 * - LOG_IN_MODAL_CLOSED
 * - LOG_IN_MODAL_OPENED
 * - ONBOARDING_MODAL_CLOSED
 * - ONBOARDING_MODAL_OPENED
 * - SEARCH_MODAL_CLOSED
 * - SEARCH_MODAL_OPENED
 * - SIGN_UP_MODAL_CLOSED
 * - SIGN_UP_MODAL_OPENED
 * - NOTIFICATIONS_MODAL_OPENED
 * - NOTIFICATIONS_MODAL_CLOSED
 * - CURRENCY_MODAL_OPENED
 * - CURRENCY_MODAL_CLOSED
 * - COMPARISON_MODAL_OPENED
 * - COMPARISON_MODAL_CLOSED
 * - PREVIEW_MODAL_OPENED
 * - PREVIEW_MODAL_CLOSED
 *
 * Action Creators:
 * - openCoinProductsModal
 * - openEventPricingModal
 * - openFavoriteModal
 * - openForgotPasswordModal
 * - openLogInModal
 * - openOnboardingModal
 * - openSearchModal
 * - openSignUpModal
 * - openNotificationsModal
 * - openCurrencyModal
 * - openComparisonModal
 * - closeCoinProductsModal
 * - closeEventPricingModal
 * - closeFavoriteModal
 * - closeForgotPasswordModal
 * - closeLogInModal
 * - closeOnboardingModal
 * - closeSearchModal
 * - closeSignUpModal
 * - closeNotificationsModal
 * - closeCurrencyModal
 * - closeComparisonModal
 */

import type {
  CoinProductsModalClosed,
  CoinProductsModalOpened,
  EventPricingModalClosed,
  EventPricingModalOpened,
  FavoriteModalClosed,
  FavoriteModalOpened,
  CardFilterModalOpened,
  CardFilterModalClosed,
  ForgotPasswordModalClosed,
  ForgotPasswordModalOpened,
  LogInModalClosed,
  LogInModalOpened,
  ModalsAction,
  ModalsState,
  OnboardingModalClosed,
  OnboardingModalOpened,
  SearchModalClosed,
  SearchModalOpened,
  SignUpModalClosed,
  SignUpModalOpened,
  NotificationsModalClosed,
  NotificationsModalOpened,
  CurrencyModalOpened,
  CurrencyModalClosed,
  ComparisonModalOpened,
  ComparisonModalClosed,
  PreviewModalOpened,
  PreviewModalClosed,
} from '../types/modals';

import {
  ACCOUNT_FETCH_SUCCEEDED,
  LOG_IN_SUCCEEDED,
  SIGN_UP_SUCCEEDED,
} from './account';

import { ROUTER_LOCATION_CHANGED } from './route';
import { PACKAGES_FETCH_REQUESTED } from './packages';
import { RESET_PASSWORD_SUCCEEDED } from './account';

import get from 'lodash/get';

import {
  pbr_modal_opened,
  pbr_modal_closed,
} from '../tracking/modals.tracking';

import type { TrackingActionWithId } from '../types/tracking';

/** @type {ActionType} */
export const LOG_IN_MODAL_OPENED = 'PB/modals/LOG_IN_MODAL_OPENED';
/** @type {ActionType} */
export const LOG_IN_MODAL_CLOSED = 'PB/modals/LOG_IN_MODAL_CLOSED';
/** @type {ActionType} */
export const ONBOARDING_MODAL_OPENED = 'PB/modals/ONBOARDING_MODAL_OPENED';
/** @type {ActionType} */
export const ONBOARDING_MODAL_CLOSED = 'PB/modals/ONBOARDING_MODAL_CLOSED';
/** @type {ActionType} */
export const SEARCH_MODAL_OPENED = 'PB/modals/SEARCH_MODAL_OPENED';
/** @type {ActionType} */
export const SEARCH_MODAL_CLOSED = 'PB/modals/SEARCH_MODAL_CLOSED';
/** @type {ActionType} */
export const SIGN_UP_MODAL_OPENED = 'PB/modals/SIGN_UP_MODAL_OPENED';
/** @type {ActionType} */
export const SIGN_UP_MODAL_CLOSED = 'PB/modals/SIGN_UP_MODAL_CLOSED';
/** @type {ActionType} */
export const FAVORITE_MODAL_OPENED = 'PB/modals/FAVORITE_MODAL_OPENED';
/** @type {ActionType} */
export const FAVORITE_MODAL_CLOSED = 'PB/modals/FAVORITE_MODAL_CLOSED';
/** @type {ActionType} */
export const CARD_FILTER_MODAL_OPENED = 'PB/modals/CARD_FILTER_MODAL_OPENED';
/** @type {ActionType} */
export const CARD_FILTER_MODAL_CLOSED = 'PB/modals/CARD_FILTER_MODAL_CLOSED';
/** @type {ActionType} */
export const FLYER_FILTER_MODAL_OPENED = 'PB/modals/FLYER_FILTER_MODAL_OPENED';
/** @type {ActionType} */
export const FLYER_FILTER_MODAL_CLOSED = 'PB/modals/FLYER_FILTER_MODAL_CLOSED';
/** @type {ActionType} */
export const NOTIFICATIONS_MODAL_CLOSED =
  'PB/modals/NOTIFICATIONS_MODAL_CLOSED';
/** @type {ActionType} */
export const NOTIFICATIONS_MODAL_OPENED =
  'PB/modals/NOTIFICATIONS_MODAL_OPENED';
/** @type {ActionType} */
export const CURRENCY_MODAL_CLOSED = 'PB/modals/CURRENCY_MODAL_CLOSED';
/** @type {ActionType} */
export const CURRENCY_MODAL_OPENED = 'PB/modals/CURRENCY_MODAL_OPENED';
/** @type {ActionType} */
export const COMPARISON_MODAL_CLOSED = 'PB/modals/COMPARISON_MODAL_CLOSED';
/** @type {ActionType} */
export const COMPARISON_MODAL_OPENED = 'PB/modals/COMPARISON_MODAL_OPENED';

/** @type {ActionType} */
export const FORGOT_PASSWORD_MODAL_OPENED =
  'PB/modals/FORGOT_PASSWORD_MODAL_OPENED';
/** @type {ActionType} */
export const FORGOT_PASSWORD_MODAL_CLOSED =
  'PB/modals/FORGOT_PASSWORD_MODAL_CLOSED';
/** @type {ActionType} */
export const COIN_PRODUCTS_MODAL_OPENED =
  'PB/modals/COIN_PRODUCTS_MODAL_OPENED';
/** @type {ActionType} */
export const COIN_PRODUCTS_MODAL_CLOSED =
  'PB/modals/COIN_PRODUCTS_MODAL_CLOSED';
/** @type {ActionType} */
export const EVENT_PRICING_MODAL_OPENED =
  'PB/modals/EVENT_PRICING_MODAL_OPENED';
/** @type {ActionType} */
export const EVENT_PRICING_MODAL_CLOSED =
  'PB/modals/EVENT_PRICING_MODAL_CLOSED';
/** @type {ActionType} */
export const PREVIEW_MODAL_OPENED = 'PB/modals/PREVIEW_MODAL_OPENED';
/** @type {ActionType} */
export const PREVIEW_MODAL_CLOSED = 'PB/modals/PREVIEW_MODAL_CLOSED';
/** @type {ActionType} */
export const FLYER_PRICING_MODAL_OPENED =
  'PB/modals/FLYER_PRICING_MODAL_OPENED';
/** @type {ActionType} */
export const FLYER_PRICING_MODAL_CLOSED =
  'PB/modals/FLYER_PRICING_MODAL_CLOSED';

export const initialState = {
  coinProductsModalOpen: false,
  eventPricingModalOpen: false,
  favoriteModalOpen: false,
  cardFilterModalOpen: false,
  flyerFilterModalOpen: false,
  forgotPasswordModalOpen: false,
  logInModalOpen: false,
  onboardingModalOpen: false,
  redirectUrl: '',
  searchModalOpen: false,
  signUpModalOpen: false,
  notificationsModalOpen: false,
  currencyModalOpen: false,
  comparisonModalOpen: false,
  previewModalOpen: false,
  flyerPricingModalOpened: false,
  previewURL: '',
  customizeURL: '',
  isUPLP: false,
  products: [],
};

/** @ignore */
export default function modals(
  state: ModalsState = initialState,
  action: ModalsAction,
) {
  switch (action.type) {
    case COIN_PRODUCTS_MODAL_OPENED:
      return { ...initialState, coinProductsModalOpen: true };
    case EVENT_PRICING_MODAL_OPENED:
      return { ...initialState, eventPricingModalOpen: true };
    case FAVORITE_MODAL_OPENED:
      return { ...initialState, favoriteModalOpen: true };
    case CARD_FILTER_MODAL_OPENED:
      return {
        ...initialState,
        cardFilterModalOpen: true,
        isUPLP: get(action, 'payload.isUPLP', false),
      };
    case FLYER_FILTER_MODAL_OPENED:
      return {
        ...initialState,
        flyerFilterModalOpen: true,
        isUPLP: get(action, 'payload.isUPLP', false),
      };
    case FORGOT_PASSWORD_MODAL_OPENED:
      return { ...initialState, forgotPasswordModalOpen: true };
    case LOG_IN_MODAL_OPENED:
    case RESET_PASSWORD_SUCCEEDED: {
      const { redirectUrl } = state;
      return { ...initialState, redirectUrl, logInModalOpen: true };
    }
    case ONBOARDING_MODAL_OPENED:
      return { ...initialState, onboardingModalOpen: true };
    case SEARCH_MODAL_OPENED:
      return { ...initialState, searchModalOpen: true };
    case SIGN_UP_MODAL_OPENED: {
      const url = get(action, 'payload.url', '');
      return { ...initialState, signUpModalOpen: true, redirectUrl: url };
    }
    case NOTIFICATIONS_MODAL_OPENED: {
      return { ...initialState, notificationsModalOpen: true };
    }
    case CURRENCY_MODAL_OPENED: {
      return { ...initialState, currencyModalOpen: true };
    }
    case COMPARISON_MODAL_OPENED: {
      return { ...initialState, comparisonModalOpen: true };
    }
    case PREVIEW_MODAL_OPENED: {
      const { previewURL, customizeURL } = get(action, 'payload');
      return {
        ...initialState,
        previewModalOpen: true,
        previewURL,
        customizeURL,
      };
    }
    case FLYER_PRICING_MODAL_OPENED: {
      const products = get(action, 'payload.products', []);
      return {
        ...initialState,
        flyerPricingModalOpen: true,
        products,
      };
    }

    case ACCOUNT_FETCH_SUCCEEDED:
    case COIN_PRODUCTS_MODAL_CLOSED:
    case EVENT_PRICING_MODAL_CLOSED:
    case FAVORITE_MODAL_CLOSED:
    case CARD_FILTER_MODAL_CLOSED:
    case FLYER_FILTER_MODAL_CLOSED:
    case FORGOT_PASSWORD_MODAL_CLOSED:
    case ONBOARDING_MODAL_CLOSED:
    case SEARCH_MODAL_CLOSED:
    case NOTIFICATIONS_MODAL_CLOSED:
    case CURRENCY_MODAL_CLOSED:
    case COMPARISON_MODAL_CLOSED:
    case PREVIEW_MODAL_CLOSED:
    case FLYER_PRICING_MODAL_CLOSED:
      return { ...initialState };

    case SIGN_UP_MODAL_CLOSED:
    case SIGN_UP_SUCCEEDED:
    case LOG_IN_MODAL_CLOSED:
    case LOG_IN_SUCCEEDED:
      const { redirectUrl } = state;
      return { ...initialState, redirectUrl };

    // Preserve cardFilterModalOpen.  We're expecting to change browser location while it's open
    case PACKAGES_FETCH_REQUESTED:
    case ROUTER_LOCATION_CHANGED:
      return {
        ...initialState,
        cardFilterModalOpen: state.cardFilterModalOpen,
        flyerFilterModalOpen: state.flyerFilterModalOpen,
        isUPLP: state.isUPLP,
      };

    default:
      return state;
  }
}

/**
 * This action creator will return a LOG_IN_MODAL_OPENED action
 *
 * @return {Action}
 * @property {string} type LOG_IN_MODAL_OPENED
 */
export function openLogInModal(): LogInModalOpened {
  return { type: LOG_IN_MODAL_OPENED };
}

/**
 * This action creator will return a SIGN_UP_MODAL_OPENED action
 *
 * @return {Action}
 * @property {string} type SIGN_UP_MODAL_OPENED
 */
export function openSignUpModal(): SignUpModalOpened {
  return { type: SIGN_UP_MODAL_OPENED };
}

/**
 * This action creator will return a SIGN_UP_MODAL_OPENED action,
 * but takes a url to direct the user to afterwards.
 *
 * @return {Action}
 * @property {string} type SIGN_UP_MODAL_OPENED
 */
export function openSignUpModalWithRedirect(url: string): SignUpModalOpened {
  return {
    type: SIGN_UP_MODAL_OPENED,
    payload: { url },
  };
}

/**
 * This action creator will return a FORGOT_PASSWORD_MODAL_OPENED action
 *
 * @return {Action}
 * @property {string} type FORGOT_PASSWORD_MODAL_OPENED
 */
export function openForgotPasswordModal(): ForgotPasswordModalOpened {
  return { type: FORGOT_PASSWORD_MODAL_OPENED };
}

/**
 * This action creator will return a LOG_IN_MODAL_CLOSED action.
 *
 * @return {Action}
 * @property {string} type LOG_IN_MODAL_CLOSED
 */
export function closeLogInModal(): LogInModalClosed {
  return { type: LOG_IN_MODAL_CLOSED };
}

/**
 * This action creator will return a SIGN_UP_MODAL_CLOSED action.
 *
 * @return {Action}
 * @property {string} type SIGN_UP_MODAL_CLOSED
 */
export function closeSignUpModal(): SignUpModalClosed {
  return { type: SIGN_UP_MODAL_CLOSED };
}

/**
 * This action creator will return a FAVORITE_MODAL_OPENED action. Used
 * to communicate that the favorite modal should be visible.
 *
 * @return {Action}
 * @property {string} type FAVORITE_MODAL_OPENED
 */
export function openFavoriteModal(): FavoriteModalOpened {
  return {
    type: FAVORITE_MODAL_OPENED,
  };
}

/**
 * This action creator will return a FAVORITE_MODAL_CLOSED action. Used
 * to communicate that the favorite modal should not be visible.
 *
 * @return {Action}
 * @property {string} type FAVORITE_MODAL_CLOSED
 */
export function closeFavoriteModal(): FavoriteModalClosed {
  return {
    type: FAVORITE_MODAL_CLOSED,
  };
}

/**
 * This action creator will return a CARD_FILTER_MODAL_OPENED action. Used
 * to communicate that the filter modal should be visible.
 *
 * @return {Action}
 * @property {string} type CARD_FILTER_MODAL_OPENED
 */
export function openCardFilterModal(
  actionButtonName,
  isUPLP,
): CardFilterModalOpened {
  return {
    type: CARD_FILTER_MODAL_OPENED,
    payload: {
      filterSelectionType: 'cardFilters',
      isUPLP,
      actionButtonName,
    },
  };
}

/**
 * This action creator will return a FLYER_FILTER_MODAL_OPENED action. Used
 * to communicate that the filter modal should be visible.
 *
 * @return {Action}
 * @property {string} type FLYER_FILTER_MODAL_OPENED
 */
export function openFlyerFilterModal(actionButtonName, isUPLP) {
  return {
    type: FLYER_FILTER_MODAL_OPENED,
    payload: {
      filterSelectionType: 'flyerFilters',
      isUPLP,
      actionButtonName,
    },
  };
}

/**
 * This action creator will return a CARD_FILTER_MODAL_CLOSED action. Used
 * to communicate that the filter modal should not be visible.
 *
 * @param {string} closeButtonName - a name for the button used to close the overlay
 * @return {Action}
 * @property {string} type CARD_FILTER_MODAL_CLOSED
 */
export function closeCardFilterModal(
  actionButtonName: string,
): CardFilterModalClosed {
  return {
    payload: {
      filterSelectionType: 'cardFilters',
      actionButtonName,
    },
    type: CARD_FILTER_MODAL_CLOSED,
  };
}

/**
 * This action creator will return a FLYER_FILTER_MODAL_CLOSED action. Used
 * to communicate that the filter modal should not be visible.
 *
 * @param {string} closeButtonName - a name for the button used to close the overlay
 * @return {Action}
 * @property {string} type FLYER_FILTER_MODAL_CLOSED
 */
export function closeFlyerFilterModal(
  actionButtonName: string,
): CardFilterModalClosed {
  return {
    payload: {
      filterSelectionType: 'flyerFilters',
      actionButtonName,
    },
    type: FLYER_FILTER_MODAL_CLOSED,
  };
}

/**
 * This action creator will return a FORGOT_PASSWORD_MODAL_CLOSED action
 *
 * @return {Action}
 * @property {string} type FORGOT_PASSWORD_MODAL_CLOSED
 */
export function closeForgotPasswordModal(): ForgotPasswordModalClosed {
  return { type: FORGOT_PASSWORD_MODAL_CLOSED };
}

/**
 * This action creator will return a COIN_PRODUCTS_MODAL_OPENED action. Used
 * to communicate that the coin modal should be visible.
 *
 * @return {Action}
 * @property {string} type COIN_PRODUCTS_MODAL_OPENED
 */
export function openCoinProductsModal(): CoinProductsModalOpened {
  return {
    type: COIN_PRODUCTS_MODAL_OPENED,
  };
}

/**
 * This action creator will return a COIN_PRODUCTS_MODAL_CLOSED action. Used
 * to communicate that the modal should _not_ be visible.
 *
 * @return {Action}
 * @property {string} type COIN_PRODUCTS_MODAL_CLOSED
 */
export function closeCoinProductsModal(): CoinProductsModalClosed {
  return {
    type: COIN_PRODUCTS_MODAL_CLOSED,
  };
}

/**
 * This action creator will return a ONBOARDING_MODAL_CLOSED action.
 *
 * @return {Action}
 * @property {string} type ONBOARDING_MODAL_CLOSED
 */
export function closeOnboardingModal(): OnboardingModalClosed {
  return { type: ONBOARDING_MODAL_CLOSED };
}

/**
 * This action creator will return a ONBOARDING_MODAL_OPENED action.
 *
 * @return {Action}
 * @property {string} type ONBOARDING_MODAL_OPENED
 */
export function openOnboardingModal(): OnboardingModalOpened {
  return { type: ONBOARDING_MODAL_OPENED };
}

/**
 * This action creator will return a SEARCH_MODAL_CLOSED action.
 *
 * @return {Action}
 * @property {string} type SEARCH_MODAL_CLOSED
 */
export function closeSearchModal(): SearchModalClosed {
  return { type: SEARCH_MODAL_CLOSED };
}

/**
 * This action creator will return a SEARCH_MODAL_OPENED action.
 *
 * @return {Action}
 * @property {string} type SEARCH_MODAL_OPENED
 */
export function openSearchModal(): SearchModalOpened {
  return { type: SEARCH_MODAL_OPENED };
}

/**
 * This action creator will return a EVENT_PRICING_MODAL_CLOSED action.
 *
 * @return {Action}
 * @property {string} type EVENT_PRICING_MODAL_CLOSED
 */
export function closeEventPricingModal(): EventPricingModalClosed {
  return { type: EVENT_PRICING_MODAL_CLOSED };
}

/**
 * This action creator will return a EVENT_PRICING_MODAL_OPENED action.
 *
 * @return {Action}
 * @property {string} type EVENT_PRICING_MODAL_OPENED
 */
export function openEventPricingModal(): EventPricingModalOpened {
  return { type: EVENT_PRICING_MODAL_OPENED };
}

/**
 * This action creator will return a NOTIFICATIONS_MODAL_CLOSED action.
 *
 * @return {Action}
 * @property {string} type NOTIFICATIONS_MODAL_CLOSED
 */
export function closeNotificationsModal(): NotificationsModalClosed {
  return { type: NOTIFICATIONS_MODAL_CLOSED };
}

/**
 * This action creator will return a NOTIFICATIONS_MODAL_OPENED action.
 *
 * @return {Action}
 * @property {string} type NOTIFICATIONS_MODAL_OPENED
 */
export function openNotificationsModal(): NotificationsModalOpened {
  return { type: NOTIFICATIONS_MODAL_OPENED };
}

/**
 * This action creator will return a CURRENCY_MODAL_OPENED action.
 *
 * @return {Action}
 * @property {string} type CURRENCY_MODAL_OPENED
 */
export function openCurrencyModal(): CurrencyModalOpened {
  return { type: CURRENCY_MODAL_OPENED };
}

/**
 * This action creator will return a CURRENCY_MODAL_CLOSED action.
 *
 * @return {Action}
 * @property {string} type CURRENCY_MODAL_CLOSED
 */
export function closeCurrencyModal(): CurrencyModalClosed {
  return { type: CURRENCY_MODAL_CLOSED };
}

/**
 * This action creator will return a COMPARISON_MODAL_OPENED action.
 *
 * @return {Action}
 * @property {string} type COMPARISON_MODAL_OPENED
 */
export function openComparisonModal(): ComparisonModalOpened {
  return { type: COMPARISON_MODAL_OPENED };
}

/**
 * This action creator will return a COMPARISON_MODAL_CLOSED action.
 *
 * @return {Action}
 * @property {string} type COMPARISON_MODAL_CLOSED
 */
export function closeComparisonModal(): ComparisonModalClosed {
  return { type: COMPARISON_MODAL_CLOSED };
}

/**
 * This action creator will return a PREVIEW_MODAL_OPENED action.
 *
 * @return {Action}
 * @property {string} type PREVIEW_MODAL_OPENED
 */
export function openPreviewModal(
  previewURL: string,
  customizeURL: string,
): PreviewModalOpened {
  return {
    type: PREVIEW_MODAL_OPENED,
    payload: {
      previewURL,
      customizeURL,
    },
  };
}

/**
 * This action creator will return a PREVIEW_MODAL_CLOSED action.
 *
 * @return {Action}
 * @property {string} type PREVIEW_MODAL_CLOSED
 */
export function closePreviewModal(): PreviewModalClosed {
  return { type: PREVIEW_MODAL_CLOSED };
}

/**
 * This action creator will return a FLYER_PRICING_MODAL_OPENED action.
 *
 * @return {Action}
 * @property {string} type FLYER_PRICING_MODAL_OPENED
 */
export function openFlyerPricingModal(products) {
  return {
    type: FLYER_PRICING_MODAL_OPENED,
    payload: { products },
  };
}

/**
 * This action creator will return a PREVIEW_MODAL_CLOSED action.
 *
 * @return {Action}
 * @property {string} type PREVIEW_MODAL_CLOSED
 */
export function closeFlyerPricingModal() {
  return {
    type: FLYER_PRICING_MODAL_CLOSED,
  };
}

/**
 * This action creator will return a pbr_modal_opened action for tracking.
 *
 * @param {string} id - the name of the type of modal that was opened
 * @property {string} type pbr_modal_opened
 * @property {string} type id
 */
export function trackModalOpen(id: string): TrackingActionWithId {
  return {
    type: pbr_modal_opened,
    payload: {
      id,
    },
  };
}

/**
 * This action creator will return a pbr_modal_closed action for tracking.
 *
 * @param {string} id - the name of the type of modal that was closed
 * @property {string} type pbr_modal_opened
 * @property {string} type id
 */
export function trackModalClosed(id: string): TrackingActionWithId {
  return {
    type: pbr_modal_closed,
    payload: {
      id,
    },
  };
}
